import { useEffect, useMemo, useRef, useState } from 'react';
import { RenderQuotePdfWorker } from './useRenderQuotePdfWorker';
import { QuotePdfProps } from '../components/FileManager/PdfGenerator';
import { captureError } from '@/utilities/error';

export const useRenderQuotePdf = (
  getProps?:
    | (QuotePdfProps | (() => QuotePdfProps | Promise<QuotePdfProps>))
    | null
) => {
  const worker = useMemo(() => new RenderQuotePdfWorker(), []);

  const loadingRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    async function renderPdf() {
      if (!worker || !getProps) return;
      if (loadingRef.current) return;
      loadingRef.current = true;
      setLoading(true);
      const props =
        typeof getProps === 'function' ? await getProps() : getProps;

      worker
        .call({ props })
        .then(({ url }) => {
          setUrl(url);
          console.log('GENERATED PDF');
        })
        .catch(captureError)
        .finally(() => {
          loadingRef.current = false;
          setLoading(false);
        });
    }

    renderPdf();
  }, [worker, getProps]);

  useEffect(() => {
    return () => {
      if (url) {
        URL.revokeObjectURL(url);
      }
    };
  }, [url]);

  return useMemo(
    () => ({
      loading,
      url,
    }),
    [loading, url]
  );
};
